import Getintouch from '../components/getintouch';
import Menu from '../components/menu';

export default function Blogs(){
    return (
        <div>
            
            <div className="sbanner">
                <div className="sbanner-inner p-5">
                    <Menu />
                    <h2 className="p-5 text-white" style={{fontWeight:"700"}}>Blogs</h2>  
                </div>
            </div>
            <h2 className="p-5">Blogs</h2>
            <Getintouch />
            
        </div>
    );
}